<template>
  <div>
    <div class="vx-col w-full">
      <div slot="no-body" class="mt-4">
          <vs-table :max-items="maxItems" @sort="handleSort" pagination stripe :data="dataSet"
                    class="table-dark-inverted table-auto vs-con-loading__container" v-if="is_data_set_array">
            <template slot="thead">
              <vs-th v-for="th in headings">{{ th.name }}</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td v-for="th in headings">
                  <span v-if="th.link">
                    <router-link :to="getColumnLink(data[indextr], th.link_key)" target="_blank">
                      {{ th.key === 'created_at' || th.key === 'updated_at'? convertString(data[indextr][th.key]): data[indextr][th.key] }}
                    </router-link>
                  </span>
                  <span v-else>
                    {{ th.key === 'created_at' || th.key === 'updated_at'? convertString(data[indextr][th.key]): ( data[indextr][th.key] ? data[indextr][th.key] : 'N/A' ) }}
                  </span>
                </vs-td>


                  <template v-if="!!sub_headings"  class="expand-user my-16" slot="expand">
                    <div class="con-expand-users w-4/5">
                      <h5 class="text-warning my-4">{{ sub_headings.data_label }}</h5>
                      <vs-table :max-items="10" pagination stripe :data="dataSet[indextr][sub_headings.data_key]"
                                class="table-dark-inverted table-auto vs-con-loading__container">
                        <template slot="thead">
                          <vs-th v-for="th in sub_headings.table_keys">{{ th.name }}</vs-th>
                        </template>
                        <template slot-scope="{data}">
                          <vs-tr :key="indextr_item" v-for="(tr_item, indextr_item) in dataSet[indextr][sub_headings.data_key]">
                            <vs-td v-for="th in sub_headings.table_keys">
                              {{ th.key === 'created_at' || th.key === 'updated_at'? convertString(tr_item[th.key]): tr_item[th.key] }}
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </template>


              </vs-tr>
            </template>
          </vs-table>
          <div class="mb-3 vx-row d-flex" v-if="is_data_set_array">
            <div>
            </div>
            <div class="vx-col md:mb-0 mr-0 ml-auto">
              <v-select style="z-index: 100" :clearable="false" :options="perPage" v-model="maxItems"></v-select>
            </div>
          </div>
          <div class="vx-row" v-if="!is_data_set_array">
            <div class="vx-col w-full">
              <span>
                <table border>
                  <tbody>
                    <tr v-for="( item, key ) in headings" :key="key">
                      <td width="40%">{{ item.name }}</td>
                      <td width="20%" class="text-right">{{ dataSet[item.key] | thousand_seperator }}</td>
                      <!-- <td width="40%"></td> -->
                    </tr>
                  </tbody>
                </table>
              </span>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import vSelect from "vue-select";
import {defaultPagination, perPageList} from "@/constants/config";

export default {
  name: "ReportTableView",
  props: {
    headings: {
      type: Array,
      required: true
    },
    sub_headings: {
      required: true,
    },
    dataSet: {
      type: Object | Array,
      required: true
    },
    meta: {
      type: Object,
      required: false,
      default: function () {
        return {
          per_page: 10
        }
      }
    },
  },
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      maxItems: 5,
      perPage: [
        '5',
        '20',
        '50',
        '100'
      ]
    }
  },
  methods: {
    humanize(str) {
      var i, frags = str.split('_');
      for (i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(' ');
    },
    convertString(str) {
      // if (moment(str, moment.ISO_8601).isValid()) {
        return moment.utc(str).local().format('DD/MM/YYYY')
      // }
      // return str;
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.loadGroups()
      }
    },
    getColumnLink(column_data, link_key) {
      const linkType = {
        'Raw Material Order': `/pages/raw-materials/orders/${column_data[link_key]}`,
        'Sundry Order': `/pages/sundry-items/orders/${column_data[link_key]}`,
        'Other Order': `/pages/other-supplier-service/orders/${column_data[link_key]}`,
      };
      return linkType[column_data.type] || '#';
    }
  },
  computed: {
    is_data_set_array() {
      return Array.isArray(this.dataSet)
    }
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}

td, th {
  text-align: left;
  padding: 8px;
}
</style>

